import { ArrowLeft, Download, Sparkles } from "lucide-react";
import { resolveParameters } from "../model/expression";
import { useModelStore } from "../state/store";
import { Viewport } from "../viewport/Viewport";

export function MotiveMode({ onExport }: { onExport: () => void }): React.JSX.Element {
  const document = useModelStore((state) => state.document);
  const updateParameterValue = useModelStore((state) => state.updateParameterValue);
  const setMode = useModelStore((state) => state.setMode);
  let resolved: Record<string, number> = {};
  try { resolved = resolveParameters(document.parameters); } catch { /* The worker shows the detailed error. */ }
  const groups = new Map<string, typeof document.exposedParameters>();
  for (const item of document.exposedParameters) groups.set(item.group, [...(groups.get(item.group) ?? []), item]);

  return (
    <div className="motive-mode">
      <aside className="motive-controls">
        <div className="motive-brand"><Sparkles size={18} /><span>Motive</span></div>
        <h1>{document.name}</h1>
        <p>{document.metadata.description ?? "Adjust the dimensions, then export your customised model."}</p>
        {groups.size === 0 && <div className="motive-empty">No parameters have been exposed for this Motive.</div>}
        {[...groups.entries()].map(([group, entries]) => (
          <section className="motive-group" key={group}>
            <h2>{group}</h2>
            {entries.map((item) => {
              const parameter = document.parameters[item.parameterId];
              if (!parameter) return null;
              const value = resolved[parameter.name] ?? (Number(parameter.value) || 0);
              const minimum = item.minimum ?? parameter.minimum ?? 0;
              const maximum = item.maximum ?? parameter.maximum ?? Math.max(value * 2, 100);
              return (
                <label className="motive-slider" key={item.parameterId}>
                  <span><strong>{item.label}</strong><output>{Number(value.toFixed(3))} {parameter.type === "angle" ? "°" : "mm"}</output></span>
                  <input type="range" min={minimum} max={maximum} step={item.step} value={Math.min(maximum, Math.max(minimum, value))} onChange={(event) => updateParameterValue(parameter.id, event.target.value)} />
                  <input type="number" min={minimum} max={maximum} step={item.step} value={Number(value.toFixed(4))} onChange={(event) => updateParameterValue(parameter.id, event.target.value)} />
                </label>
              );
            })}
          </section>
        ))}
        <div className="motive-actions">
          <button className="button primary full" onClick={onExport}><Download size={16} /> Export model</button>
          <button className="button ghost full" onClick={() => setMode("design")}><ArrowLeft size={16} /> Open full design</button>
        </div>
        <div className="motive-local-note">100% local · no upload · no account</div>
      </aside>
      <main className="motive-viewport"><Viewport /></main>
    </div>
  );
}
